module.exports = __webpack_public_path__ + "media/images/details__prizeBox__stretch__third-44730efaeaa2c7bfec2bdafbe51ef66a.png";